/**
 * SPA เดียว 3 หน้า (HANDOFF.md §เว็บ 2 ส่วน)
 *
 * ใช้ DOM ตรงๆ ไม่พึ่ง framework — ทั้งสามหน้าเป็น UI ล้วน ไม่มี state ซับซ้อน
 * และกฎในโปรเจกต์ห้ามเพิ่ม dependency ที่ไม่ใช่ dev โดยไม่ถามก่อน
 */
import { renderMe } from "./pages/me.js";
import { renderPlay } from "./pages/play.js";
import { renderRegister } from "./pages/register.js";

const root = document.getElementById("app")!;
let cleanup: (() => void) | void;

function route(): void {
  if (typeof cleanup === "function") cleanup();
  cleanup = undefined;
  root.innerHTML = "";

  const path = location.pathname.replace(/\/+$/, "") || "/";
  const reg = /^\/r\/(\d)$/.exec(path);

  if (reg) {
    const stationId = Number(reg[1]);
    const nonce = new URLSearchParams(location.search).get("n") ?? "";
    if (!nonce) {
      root.innerHTML = `
        <div class="title">PLAYER YOU</div>
        <div class="kick">LINK EXPIRED</div>
        <div class="lbl">ลิงก์ไม่สมบูรณ์</div>
        <div class="note">สแกน QR จากจอลงทะเบียนอีกครั้งนะครับ — รหัสมีอายุ <b>60 วินาที</b></div>`;
      return;
    }
    renderRegister(root, stationId, nonce);
    return;
  }

  if (path === "/me") {
    renderMe(root);
    return;
  }

  if (path === "/play") {
    cleanup = renderPlay(root);
    return;
  }

  root.innerHTML = `
    <div class="title">PLAYER YOU</div>
    <div class="kick">SCAN TO CREATE YOUR AVATAR</div>
    <div class="lbl">เริ่มต้น</div>
    <div class="note">สแกน QR ที่จอลงทะเบียน (ฐาน 00) เพื่อถ่ายรูปและสร้างตัวละครของคุณ</div>
    <div class="row" style="margin-top:20px">
      <button class="ghost" id="to-me">ตัวละครของฉัน</button>
      <button class="ghost" id="to-play">คอนโทรลเลอร์</button>
    </div>`;
  root.querySelector("#to-me")!.addEventListener("click", () => { location.href = "/me"; });
  root.querySelector("#to-play")!.addEventListener("click", () => { location.href = "/play"; });
}

window.addEventListener("popstate", route);
route();
